import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { takeWhile, concatMap } from 'rxjs';
import { MasterDataService } from 'src/app/services/master-data.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { CareerService } from 'src/app/services/career.service';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})
export class CareersComponent implements OnInit {
@ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  specialities!: any[];
  keywords: any[] = [];
  filteredKeywords: any[] = [];
  keywordsControl = new FormControl('');
  isNew: boolean = false;
  selectTab: number = 0;

  searchJobForm = new FormGroup({
    speciality: new FormControl(''),
    keywords: new FormControl(''),
  });

  constructor(private readonly masterDataService: MasterDataService, private readonly careerService: CareerService, private readonly router: Router, private readonly route: ActivatedRoute,private readonly localStorageService: LocalStorageService, private breakPointObserver: BreakpointObserver) {
    window.addEventListener('scroll', this.scrollEvent, true);
  }
  
  filteredSpecialities: any[] = [];
  ngOnInit(): void {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.checkAllBreakPoints();
    this.loadSpecialities();
    this.loadKeywords();
    this.localStorageService.getUserDetails().subscribe(data => {
      this.isNew = !data || !data.userId;
    });
    this.keywordsControl.valueChanges.subscribe(value => {
      this.searchJobForm.get('keywords')?.setValue(value);
      this.filteredKeywords = this.keywords.filter(keyword =>
        keyword.name.toLowerCase().includes(value?.toLowerCase().trim())
      );
    });
  }
  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if(autoComplete.panelOpen){
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    })
    if(!isScrollingInsidePanel){
      this.closeAllPanels();
    }
  }

  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }
  checkAllBreakPoints() {
    this.breakPointObserver.observe([
      '(max-width: 767.98px)'
    ]).subscribe(r => {
      if(r.matches) {
        if(r.breakpoints['(max-width: 767.98px)']) {
          this.resetScrollSettings();
        }
      }
    })
  }

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;
 
      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }

  private loadSpecialities() {
    let pageNumber = 0;
    let pageSize = 100;
    let allSpecialities: any[] = [];
    let morePages = true;

    this.masterDataService.getSpecialities(pageNumber, pageSize, '')
      .pipe(
        takeWhile(() => morePages),
        concatMap(response => {
          if (response.data.length === 0) {
            morePages = false;
            return [];
          }
          allSpecialities = allSpecialities.concat(response.data);
          pageNumber++;
          return this.masterDataService.getSpecialities(pageNumber, pageSize, '');
        })
      )
      .subscribe(data => {
        allSpecialities = allSpecialities.concat(data.data);
        this.specialities = allSpecialities;
      });
  }
  onSpecialityFilter(event: Event): void {
    const input = event.target as HTMLInputElement;  
    const searchTerm = input?.value.toLowerCase().trim();
    this.filteredSpecialities = this.specialities.filter(speciality =>
      speciality.specialty.toLowerCase().includes(searchTerm)
    );
  }
  onFocusSpeciality(): void {
    this.filteredSpecialities = this.specialities;
  }

  loadKeywords(): void {
    this.careerService.searchSuggestions('')
      .subscribe(response => {
        if (response && response.data) {
          this.keywords = response.data;
          this.filteredKeywords = [...this.keywords];
        }
      });
  }
  
  onKeywordsFilter(event: Event): void {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value.toLowerCase().trim();
  
    this.filteredKeywords = this.keywords.filter(keyword =>
      keyword.name.toLowerCase().includes(searchTerm)
    );
  }
  
  onFocusKeywords(): void {
    this.filteredKeywords = [...this.keywords];
  }

  onSubmit() {
    const searchJobForm = this.searchJobForm.value;
    if(this.validateFields(searchJobForm.speciality) === null && this.validateFields(searchJobForm.keywords) === null) {
      this.router.navigate(['/jobs/view-all-jobs']);
    }
    else if (this.validateFields(searchJobForm.speciality) !== null || this.validateFields(searchJobForm.keywords) !== null) {
      this.router.navigate(['./view-all-jobs'], {
        relativeTo: this.route, queryParams: {
          speciality: this.validateFields(searchJobForm.speciality),
          keywords: this.validateFields(searchJobForm.keywords),
        },
      });
    }
  }

  onViewAllJobs() {
    this.router.navigate(['./view-all-jobs'], { relativeTo: this.route });
  }

  private validateFields(value: any) {
    return (value != undefined && value != null && value.length > 0) ? value : null;
  }

  activeTab(tabNumber: number){
    this.selectTab = tabNumber;
  }
  mobileSearchSubmit() {
    this.onSubmit();
  }
}
